import { render, staticRenderFns } from "./DepartureList.vue?vue&type=template&id=cf0fbf36&"
import script from "./DepartureList.vue?vue&type=script&lang=js&"
export * from "./DepartureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports